import axios from 'axios';

const base = '/api/v1/lwadmin/trending';

export function getPaginated(page) {
  return axios.get(`${base}`, {
    params: { page },
    cache: { ignoreCache: true },
  });
}

export function recalcAllWires() {
  return axios.post(`${base}/_trigger_trending_recalc_for_all_wires`);
}

export function getWireStats(wid) {
  return axios.get(`${base}/_get_wire_statistics`, {
    params: { id: wid },
    cache: { ignoreCache: true },
  });
}
